// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropDown_dropdown_1gorS","label":"dropDown_label_13dmH"};